module.exports = __webpack_public_path__ + "static/media/prototype-enfase.313bb4b8.mp4";